import {getData, LOGIN} from "../storage";
import {isEmpty} from "../utility";

export const acceptUserRequestAndCreateNewBroadcast = (props, viewer_id, callback) => {


    const formData = {
        session_title: props.initialValues.session_title,
        session_description: props.initialValues.session_description,
        broadcast_type: props.initialValues.broadcast_type,
        one_to_one_session_allow: props.initialValues.one_to_one_session_allow,
        one_to_one_session_price: props.initialValues.one_to_one_session_price,
        group_session_price: props.initialValues.group_session_price,
        is_chat_allowed: true,
        is_hls: false,
        device: props.device,
        broadcast_id: props.initialValues.id.toString()
    };

    getData(LOGIN)
        .then((data) => {
            if (!isEmpty(data)) {
                callback(formData);
                props.createPrivateBroadcast(data.token, data.api_token, formData);
            }
        })
}